<template>
  <generic-modal
    size
    :title="$t('product')"
    icon="box"
    image="/images/icons/product.png"
    v-bind:scrolling="false"
    v-on:destroy="destroy"
    v-bind:on_finished="this.finished"
  >
    <div class="description">
      <div class="ui form" ref="form">
        <h3 class="ui dividing header">{{ $t("basic information") }}</h3>
        <div class="two fields">
          <div class="six column wide field">
            <label for>{{ $t("name") }}</label>
            <input type="text" name="name" v-model="name" />
          </div>
          <div class="ten column wide field">
            <label for>{{ $t("description") }}</label>
            <textarea
              name="description"
              rows="2"
              v-model="description"
            ></textarea>
          </div>
        </div>
        <div class="ui four item pointing secondary menu" ref="tabs">
          <a class="item active" data-tab="general">
            <i class="info circle icon"></i>
            {{ $t("general information") }}
          </a>
          <a class="item" data-tab="attributes">
            <i class="list icon"></i>
            {{ $t("attributes") }}
          </a>
          <a class="item" data-tab="price_variations">
            <i class="list icon"></i>
            {{ $t("price variations") }}
          </a>
          <a class="item" data-tab="compoundmnt">
            <i class="cubes icon"></i>
            {{ $t("compoundment") }}
          </a>
        </div>
        <div class="ui tab segment active" data-tab="general">
          <div class="two fields">
            <div class="field">
              <label for>{{ $t("barcode") }}</label>
              <div class="ui left icon input">
                <input type="text" name="barcode" v-model="barcode" />
                <i class="barcode icon"></i>
              </div>
            </div>
            <div class="field">
              <label for>{{ $t("internal reference") }}</label>
              <div class="ui left icon input">
                <input
                  type="text"
                  name="internal_reference"
                  v-model="internal_reference"
                />
                <i class="asterisk icon"></i>
              </div>
            </div>
          </div>
          <div class="three fields">
            <div class="field">
              <label for>{{ $t("sale price") }}</label>
              <div class="ui left icon input">
                <input type="text" name="sale_price" v-model="sale_price" />
                <i class="money bill icon"></i>
              </div>
            </div>
            <div class="field">
              <label for>{{ $t("cost") }}</label>
              <div class="ui left icon input">
                <input type="text" name="cost" v-model="cost" />
                <i class="money bill icon"></i>
              </div>
            </div>
            <div class="field">
              <label for>{{ $t("taxes percentage") }}</label>
              <div class="ui left icon input">
                <input
                  type="text"
                  name="taxes_percentage"
                  v-model="setup.taxes_percentage"
                />
                <i class="percent icon"></i>
              </div>
            </div>
          </div>
          <div class="fields">
            <div class="field">
              <div class="ui toggle checkbox" ref="available_for_sale">
                <input
                  type="checkbox"
                  name="available_for_sale"
                  v-model="available_for_sale"
                />
                <label>{{ $t("available for sale") }}</label>
              </div>
            </div>
            <div class="field">
              <div class="ui toggle checkbox" ref="available_for_purchase">
                <input
                  type="checkbox"
                  name="available_for_purchase"
                  v-model="available_for_purchase"
                />
                <label>{{ $t("available for purchase") }}</label>
              </div>
            </div>
          </div>
        </div>
        <div class="ui tab segment" data-tab="attributes">
          <div class="fields">
            <div
              class="eight wide column field"
              v-for="(attribute, index) in setup.attributes"
              v-bind:key="index"
            >
              <label for>{{ attribute.display_name }}</label>
              <input
                type="text"
                v-model="setup.attributes[index].value"
                :name="attribute.field_name"
                v-if="['text', 'email', 'numeric'].includes(attribute.type)"
              />
              <div
                class="ui calendar"
                ref="calendar"
                v-if="['date'].includes(attribute.type)"
                :data-index="index"
              >
                <div class="ui input left icon">
                  <i class="calendar icon"></i>
                  <input
                    type="text"
                    placeholder="Date/Time"
                    v-model="setup.attributes[index].value"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="ui tab segment" data-tab="price_variations">
          <div class="fields">
            <div
              class="field"
              v-for="(vr, idx) in setup.variations"
              :key="vr.id"
            >
              <label for>{{ vr.display_name }}</label>
              <input
                type="text"
                name="price"
                v-model="setup.variations[idx].value"
              />
            </div>
          </div>
        </div>
        <div class="ui tab segment" data-tab="compoundmnt">
          <div class="field">
            <div class="ui toggle checkbox" ref="is_compound">
              <input type="checkbox" name="is_compound" v-model="is_compound" />
              <label>{{ $t("is compound product") }}</label>
            </div>
          </div>
          <product-compoundment
            v-if="is_compound"
            :product_in="product"
            ref="compoundment"
          />
        </div>
        <div class="ui error message"></div>
      </div>
    </div>
  </generic-modal>
</template>

<script>
import { local_api, error_toast } from "@/utils";
import _ from "lodash";
import GenericModal from "@/components/GenericModal";
import ProductCompoundment from "./ProductCompoundment";

export default {
  name: "ProductModal",
  components: {
    "generic-modal": GenericModal,
    ProductCompoundment,
  },
  computed: {},
  props: { product: Object },
  data() {
    return {
      name: "",
      description: "",
      barcode: "",
      internal_reference: "",
      available_for_purchase: true,
      available_for_sale: true,
      sale_price: 0,
      cost: 0,
      setup: {
        attributes: [],
        variations: [],
        taxes_percentage: 0,
        compoundment: [],
      },
      is_compound: false,
    };
  },
  methods: {
    finished() {
      let vm = this;
      return new Promise(function(resolve, reject) {
        let isValid = window.jQuery(vm.$refs.form).form("validate form");

        if (!isValid) reject();
        else {
          let _setup = _.clone(vm.setup);

          _setup.attributes = vm.setup.attributes.map((attr) => {
            return { name: attr.display_name, value: attr.value };
          });
          _setup.variations = vm.setup.variations.map((attr) => {
            return { name: attr.display_name, value: attr.value };
          });
          _setup.is_compound = vm.is_compound || false;
          _setup.compoundment = vm.$refs.compoundment
            ? vm.$refs.compoundment.getList()
            : [];

          local_api(vm, "post", "/product/do-save", {
            i: vm.product ? vm.product.uuid : undefined,
            n: vm.name,
            d: vm.description,
            s: _setup,
            b: vm.barcode,
            t: vm.internal_reference,
            as: vm.available_for_sale,
            ap: vm.available_for_purchase,
            sp: vm.sale_price,
            ct: vm.cost,
            // s: {
            //   attributes: vm.setup.attributes.map(attr => {
            //     return { name: attr.display_name, value: attr.value };
            //   }),
            //   available_for_purchase: vm.setup.available_for_purchase,
            //   available_for_sale: vm.setup.available_for_sale
            // }
          })
            .then((product) => {
              vm.$emit("succedded", product);
              resolve();
            })
            .catch((err) => {
              reject(err);
            });
        }
      });
    },
    destroy() {
      this.$emit("destroy");
      // this.$destroy();
    },
  },
  mounted() {
    let vm = this;
    local_api(this, "post", "/product/do-get-configuration")
      .then((conf) => {
        if (conf && conf.setup && conf.setup.attributes) {
          if (vm.product && vm.product.product_id) {
            vm.name = vm.product.name;
            vm.description = vm.product.description;
            vm.barcode = vm.product.barcode;
            vm.internal_reference = vm.product.internal_reference;
            vm.available_for_purchase = vm.product.available_for_purchase;
            vm.available_for_sale = vm.product.available_for_sale;
            vm.sale_price = vm.product.sale_price;
            vm.cost = vm.product.cost;
          }

          if (vm.product) vm.setup = _.clone(vm.product.setup);
          vm.setup.taxes_percentage = vm.setup.taxes_percentage || 0;

          vm.setup.compoundment = conf.setup.compoundment || [];
          vm.is_compound = vm.setup.is_compound;

          vm.setup.attributes = conf.setup.attributes.map((att) => {
            let val = "";
            if (vm.product && vm.product.product_id) {
              let trgtAttr = vm.product.setup.attributes.find(
                (n) => n.name == att.name,
              );
              if (trgtAttr) val = trgtAttr.value;
            }
            return {
              id: att.id,
              type: att.type,
              display_name: att.name,
              field_name: att.name.toLowerCase().replace(" ", "_"),
              value: val,
            };
          });

          if (vm.product && !vm.product.setup.variations)
            vm.product.setup.variations = [];
          vm.setup.variations = conf.setup.variations.map((att) => {
            let val = "";
            if (vm.product && vm.product.product_id) {
              let trgtAttr = vm.product.setup.variations.find(
                (n) => n.name == att.name,
              );
              if (trgtAttr) val = trgtAttr.value;
            }
            return {
              id: att.id,
              display_name: att.name,
              field_name: att.name.toLowerCase().replace(" ", "_"),
              value: val,
            };
          });

          window.jQuery(vm.$refs.form).form({
            fields: {
              name: ["empty"],
              cost: ["number"],
              sale_price: ["number"],
              taxes_percentage: ["integer[0..100]"],
            },
          });
        }
      })
      .catch((err) => {
        error_toast(err);
      });

    window
      .jQuery(vm.$refs.tabs)
      .find(".item")
      .tab();
  },
  watch: {},
  updated: function() {},
};
</script>
